import { render, staticRenderFns } from "./AtencionClienteMediado.vue?vue&type=template&id=67133d0b&scoped=true&"
var script = {}
import style0 from "./AtencionClienteMediado.vue?vue&type=style&index=0&id=67133d0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67133d0b",
  null
  
)

export default component.exports